import chatBubbleGreyIcon from 'assets/images/icons/chat_bubble-grey.svg';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
// import { FiveStarsWhite } from 'assets/icons';

// === M1 | General ===

export const buySectionTitle = 'Buy M1';

export const buySectionDescription = (
  <>
    {/* <b style={{ display: 'inline-block', margin: '0.4rem 0 0.4rem 0' }}>
      Scan based experience (NFC required)
    </b>
    <br /> */}
    Discover a personalized way to eat better and exercise smarter using the
    real-time glucose biomarker.
  </>
);

export const carousalSection_m1_in = [
  {
    src: 'web_v2/m1/carousel/4.4.png',

    srcResponsive: 'web_v2/m1/carousel/4.4-mobile.png',

    thumb: 'web_v2/m1/carousel/4.3.png',

    alt: '',
  },
  {
    src: 'web_v2/m1/carousel/2.1.png',

    srcResponsive: 'web_v2/m1/carousel/2.1.png',

    thumb: 'web_v2/m1/carousel/2.1.png',

    alt: '',
  },
  {
    src: 'web_v2/m1/carousel/3.1.png',

    srcResponsive: 'web_v2/m1/carousel/3.1.png',

    thumb: 'web_v2/m1/carousel/3.1.png',

    alt: '',
  },

  {
    src: 'web_v2/m1/carousel/1.1.png',
    srcResponsive: 'web_v2/m1/carousel/1.1.png',

    thumb: 'web_v2/m1/carousel/1.1.png',

    alt: '',
  },
];

export const carousalSection_m1 = [
  {
    src: 'web_v2/m1/carousel/1.png',
    srcResponsive: 'web_v2/m1/carousel/1.png',

    thumb: 'web_v2/m1/carousel/1.png',

    alt: '',
  },
  {
    video: true,
    src: 'https://public-web-assets-cfront.ultrahuman.com/m1/Ultrahuman-M1-Product_Video.mp4',
    poster: getCompressedAssetUrl('/m1/m1_vid_poster.png'),
    thumb: 'm1/m1_vid_thumbnail.png',

    alt: '',
  },
  {
    src: 'web_v2/m1/carousel/2.png',

    srcResponsive: 'web_v2/m1/carousel/2.png',

    thumb: 'web_v2/m1/carousel/2.png',

    alt: '',
  },
  {
    src: 'web_v2/m1/carousel/3.png',

    srcResponsive: 'web_v2/m1/carousel/3.png',

    thumb: 'web_v2/m1/carousel/3.png',

    alt: '',
  },
  {
    src: 'web_v2/m1/carousel/4.1.png',

    srcResponsive: 'web_v2/m1/carousel/4.1.png',

    thumb: 'web_v2/m1/carousel/4.1.png',

    alt: '',
  },
];

// === M2 Live | US Specific ===
export const carousalSection_m1_us = [
  {
    src: 'web_v2/m2/carousel/1.png',
    srcResponsive: 'web_v2/m2/carousel/1.png',
    thumb: 'web_v2/m2/carousel/1.png',
    alt: 'Ultrahuman M2 Live CGM',
  },
  {
    src: 'web_v2/m2/carousel/2.png',
    srcResponsive: 'web_v2/m2/carousel/2.png',
    thumb: 'web_v2/m2/carousel/2.png',
    alt: 'Ultrahuman M2 Live CGM',
  },
  {
    src: 'web_v2/m2/carousel/3.png',
    srcResponsive: 'web_v2/m2/carousel/3.png',
    thumb: 'web_v2/m2/carousel/3.png',
    alt: 'Ultrahuman M2 Live CGM',
  },
  {
    src: 'web_v2/m2/carousel/4.png',
    srcResponsive: 'web_v2/m2/carousel/4.png',
    thumb: 'web_v2/m2/carousel/4.png',
    alt: 'Ultrahuman M2 Live CGM',
  },
  {
    src: 'web_v2/m2/carousel/5.png',
    srcResponsive: 'web_v2/m2/carousel/5.png',
    thumb: 'web_v2/m2/carousel/5.png',
    alt: 'Ultrahuman M2 Live CGM',
  },
];

export const carousalSection_m1_eu_gb = [
  {
    src: 'web_v2/m1/carousel/1.png',
    srcResponsive: 'web_v2/m1/carousel/1.png',

    thumb: 'web_v2/m1/carousel/1.png',

    alt: '',
  },
  {
    src: 'web_v2/m1/carousel/2.png',

    srcResponsive: 'web_v2/m1/carousel/2.png',

    thumb: 'web_v2/m1/carousel/2.png',

    alt: '',
  },
  {
    src: 'web_v2/m1/carousel/3.png',

    srcResponsive: 'web_v2/m1/carousel/3.png',

    thumb: 'web_v2/m1/carousel/3.png',

    alt: '',
  },
  {
    src: 'web_v2/m1/carousel/4.1.png',

    srcResponsive: 'web_v2/m1/carousel/4.1.png',

    thumb: 'web_v2/m1/carousel/4.1.png',

    alt: '',
  },
];

export const descriptionSection1_m1 = {
  title: 'What?',
  items: [
    {
      image: 'FoodOptimization.png',
      imageAlt: '',
      title: 'Personalized food suggestions',
      description: (
        <>
          Discover foods that work for you and optimize the ones that
          don&apos;t. Based on unique glucose metabolism insights,{' '}
          <b>identify foods</b> that give you a stable glucose response
        </>
      ),
    },
    {
      image: 'FuelBetter.png',
      imageAlt: '',
      title: 'Fuel better for your next workout',
      description: (
        <>
          Fuel better for your workouts and sports. Know if you’re{' '}
          <b>under fueled</b>, <b>optimally fueled</b> or <b>over fueled</b> for
          your activities. Improve performance and recovery
        </>
      ),
    },
    {
      image: 'Sleepoptimization.png',
      imageAlt: '',
      title: 'Optimize sleep time glucose',
      description: (
        <>
          Your glucose levels during sleep hours affect your{' '}
          <b>sleep quality</b> and <b>recovery</b>. Optimize these via the
          nocturnal glucose insights
        </>
      ),
    },
  ],
};
export const descriptionSection2_m1 = {
  title: 'Why?',
  description: (
    <>
      Your glucose variations are an indicator of your metabolic fitness.
      Metabolism indicates your <b>fat burning ability</b>, <b>energy levels</b>
      , <b>metabolic disorder risk</b>, <b>athletic performance</b> and{' '}
      <b>sexual health</b>
      <br />
      <br />
      85% of all chronic diseases in the world are <b>metabolic disorders</b>,
      like diabetes, hypertension, PCOS/PMOS and obesity
    </>
  ),
  image: 'why_ultrahuman.png',
  imageAltText: '',
};
export const descriptionSection3_m1 = {
  title: 'How?',
  items: [
    {
      image: 'real-time-glucose-tracking-grey-bg.png',
      imageAlt: '',
      title: 'Real-time glucose monitoring',
      description: 'Track your real-time glucose with just a quick scan.',
      order: 1,
    },
    {
      image: 'food-score-grey-bg.png',
      imageAlt: '',
      title: 'Food Score',
      description:
        'Measure the impact of different foods on your health with the food score and get methods to optimize it',
      order: 3,
    },
    {
      image: 'performance-coach-grey-bg.png',
      imageAlt: '',
      title: 'Performance Coaches',
      description:
        'Get personalized food and exercise guidance to improve your metabolic fitness. Our performance coaches are NSCA certified sports scientists and exercise physiologists',
      order: 5,
    },
    {
      image: 'track-sleeo-stress-fasting-grey-bg.png',
      imageAlt: '',
      title: 'Track Sleep, Stress, Fasting',
      description:
        'Continuously monitor your glucose response to various lifestyle events, like sleep, stress, fasting and other events',
      order: 7,
    },
    {
      image: 'cyborg-army-ull-width.png',
      imageAlt: '',
      title: 'Cyborg Army',
      description:
        'Get access to the world’s fastest growing community of like-minded athletes, biohackers and longevity enthusiasts',
      order: 9,
    },

    {
      image: 'Metabolic-score-grey-bg.png',
      imageAlt: '',
      title: 'Metabolic Score',
      description:
        'Visualize your metabolic fitness in real-time with the metabolic score. Learn how lifestyle changes affect your health',
      order: 2,
    },
    {
      image: 'fuel-score-grey-bg.png',
      imageAlt: '',
      title: 'Fueling Score',
      description:
        'Maximize your sports and workout performance using the fueling score. Understand which foods and lifestyle habits help you improve performance and focus during activities',
      order: 4,
    },
    {
      image: 'Timeline-image-new.png',
      imageAlt: '',
      title: 'Metabolic Nudges',
      description:
        'Get personalised nudges and insights to improve your metabolic fitness',
      order: 6,
    },
    {
      image: 'metabolic-vectors-grey-bg.png',
      imageAlt: '',
      title: 'Metabolic Vectors',
      description:
        'Optimize your metabolic fitness along different vectors, such as focus, longevity and athletic',
      order: 8,
    },
  ],
};
export const descriptionSection4_m1 = {
  title: 'Trusted by the Best',
  items: [
    {
      image: 'HS-Pranoy-desktop.png',
      imageResponsive: 'pranoy-responsive.png',
      imageAlt: '',
      title: 'HS Prannoy',
      description: 'Indian Badminton Champion',
    },
    {
      image: 'Robin.png',
      imageResponsive: 'robin-responsive.png',
      imageAlt: '',
      title: 'Robin Singh',
      description: 'Indian Football Champion',
    },
    {
      image: 'Aishwarya.png',
      imageResponsive: 'aishwarya-responsive.png',
      imageAlt: '',
      title: 'Aishwarya Pissay',
      description: 'Indian circuit and Off-road Motorcycle World Champion',
    },
    {
      image: 'Naveen.png',
      imageResponsive: 'naveen-responsive.png',
      imageAlt: '',
      title: 'Naveen John',
      description: '4 time winner of the Indian National Cycling Championships',
    },
    {
      image: 'Kieren.png',
      imageResponsive: 'kieren-responsive.png',
      imageAlt: '',
      title: 'Kieren Dsouza',
      description: 'Ultramarathon Runner and Endurance Athlete',
    },
    {
      image: 'Varsha.png',
      imageResponsive: 'varsha-responsive.png',
      imageAlt: '',
      title: 'Varsha Rohit',
      description: '3-time National Gold Medalist Sprinter',
    },
    {
      image: 'Kabir.png',
      imageResponsive: 'karan-responsive.png',
      imageAlt: '',
      title: 'Kabir Rachure',
      description: 'Ultra Cyclist ',
    },
  ],
};

export const testimonialSection_m1 = {
  title: 'User Testimonials',
  items: [
    {
      userIcon: 'bandukwala_tweet.png',
      userName: 'Bandukwala',
      userHandle: '@aadil',
      href: 'https://twitter.com/aadil/status/1449329974855434243?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E1449329974855434243%7Ctwgr%5E%7Ctwcon%5Es1_&ref_url=https%3A%2F%2Fultrahuman.com%2Fwall-of-love',
      content: {
        text: (
          <>
            Stepped out for lunch today. Was craving Asian food. Ordered an
            appetizer - Hot Garlic Chicken.
            <br />
            <br />
            Requested the Chef not to add any sugar to the dish.
            <br />
            <br />
            The order came in. Was delicious. Until I saw my @UltrahumanHQ
            Cyborg point out my glucose was up 40 points from 75 to 115!
          </>
        ),
        image: 'aadil_tweet.png',
      },
    },
    {
      userIcon: 'prashant_dp.png',
      userName: 'Prashanth K S',
      userHandle: '@ksprashu',
      href: 'https://twitter.com/ksprashu/status/1445046606303166470?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E1445046606303166470%7Ctwgr%5E%7Ctwcon%5Es1_&ref_url=https%3A%2F%2Fultrahuman.com%2Fwall-of-love',
      content: {
        text: (
          <>
            #biohacking with
            <br />
            @UltrahumanHQ
            <br />
            <br />
            Superbly managed my blood glucose till noon.
            <br />
            The secret was following up each (carby) meal with whey protein.
            Protein has been shown to delay insulin spike.
            <br />
            <br />
            Downside was the mad release of all glucose post noon when I was
            driving around.
          </>
        ),
        image: 'prashanth_tweet.png',
      },
    },
    {
      userIcon: 'kunal_dp.png',
      userName: 'Kunal Walia',
      userHandle: '@KunalWalia',
      href: 'https://twitter.com/KunalWalia/status/1449664767677796357?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E1449664767677796357%7Ctwgr%5E%7Ctwcon%5Es1_&ref_url=https%3A%2F%2Fultrahuman.com%2Fwall-of-love',
      content: {
        text: 'Sunday done right? @UltrahumanHQ I know the crisps and @sleepyowlcoffee are making you nervous! Promise a run to make up #Avocado',
        image: 'kunal_tweet.png',
      },
    },

    {
      userIcon: 'gayatri_dp.png',
      userName: 'Gayatri Vasudeva Yadav',
      userHandle: '@GayatriPYadav',
      href: 'https://twitter.com/GayatriPYadav/status/1441001515372531713?ref_src=twsrc%5Etfw%7Ctwcamp%5Etweetembed%7Ctwterm%5E1441001515372531713%7Ctwgr%5E%7Ctwcon%5Es1_&ref_url=https%3A%2F%2Fultrahuman.com%2Fwall-of-love',
      content: {
        text: <>@UltrahumanHQ my journey begins today...</>,
        image: 'gayatri_tweet.png',
      },
    },
  ],
};

export const reviewsForAllSection_m1 = {
  title_a: 'Made for all',
  subtitle_a: '4.6 out of 5 stars from 25,000+ subscribers',
  title_b: 'User Reviews',
  app_store: {
    head: 'App store',
    store_icon: '../../assets/images/app_store_icon.svg',
    store_rating: '4.9',
    cta_text: 'Download on AppStore',
    cta_redirect:
      'https://apps.apple.com/us/app/ultrahuman-meditation-sleep/id1491286709',
  },
  play_store: {
    head: 'Play store',
    store_icon: '../../assets/images/app_store_icon.svg',
    store_rating: '4.5',
    cta_text: 'Download on Playstore',
    cta_redirect:
      'https://play.google.com/store/apps/details?id=com.ultrahuman.android',
  },
  itemsForAll: [
    {
      title: 'Proud to be a Cyborg',
      userName: 'Hpatiluk',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '30 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Generally I never review however here would like to congratulate the
            #Ultrahuman team for this app and insight on health management.
            Rated 5 star as everything is awesome from onboarding, sensor
            delivery, app UI, activity classes, customer service, etc. Thanks!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The API for your body',
      userName: 'ApoorvSharma',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '14 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            What an amazing app experience and deep insights into how your body
            works. This truly goes out to show how each body is different and
            how nutrition can have an impact on us. Strongly recommend trying it
            at least once. Your life will never be the same!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Great tech and even better team',
      userName: 'AK_AK_AK',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '29 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            This is a game-changer and has helped me understand multiple aspect
            of my metabolic health made me conscious about the way I eat and
            what I eat, also Ultrahuman team is super super responsive and
            helpful really loving the experience.
          </>
        ),
      },
      starCount: 5,
    },
  ],
  items: [
    {
      title: 'Proud to Be Cyborg',
      userName: 'Hpatiluk',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '30 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Generally I never review however here would like to congratulate the
            #Ultrahuman team for this app and insight on health management.
            Rated 5 star as everything is awesome from onboarding, sensor
            delivery, app UI, activity classes, customer service, etc. Thanks!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The API for your body',
      userName: 'ApoorvSharma',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '14 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            What an amazing app experience and deep insights into how your body
            works. This truly goes out to show how each body is different and
            how nutrition can have an impact on us. Strongly recommend trying it
            at least once. Your life will never be the same!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Great tech and even better team',
      userName: 'AK_AK_AK',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '29 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            This is a game-changer and has helped me understand multiple aspect
            of my metabolic health made me conscious about the way I eat and
            what I eat, also Ultrahuman team is super super responsive and
            helpful really loving the experience.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Brilliant app',
      userName: 'Rakannan',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '29 Jul 2022',
      since: 'Sep 2022',
      to: 'XXX XX',
      content: {
        text: (
          <>
            The concept of using CGM to guide your training and food plan is
            brilliant. The app is also very well laid out.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'In love with the app',
      userName: 'Nayanava',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '6 Oct 2022',
      since: 'Aug 2022',
      to: 'XXX XX',
      content: {
        text: (
          <>
            This has to be the best device after Apple Watch which helps track
            the blood glucose levels, in turn helping maintain a healthy
            lifestyle by allowing me make the right food choices while staying
            away from the others. It has kind of become like a challenge to
            maintain blood glucose levels below 110 now throughout the day!! I
            have quit almost all foods that have added sugar.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The Ultrahuman Cyborg experience',
      userName: 'Athif Hasan',
      purchase: 'Repeat purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '23 Nov 2022',
      since: 'Sep 2022',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Ultrahuman M1 gave me a complete insight the impact every food has
            to my body. Did not follow any fancy diet, yet managed to educate
            myself around food, and built a sustainable & healthy lifestyle.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Absolutely Amazing! Its an integrated part of my body!',
      userName: 'Ranger3010',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '25 Jun 2022',
      since: 'Sep 2022',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Ultrahuman sensors are easy to wear and very effective in diet
            control. It helps me track my calorie intake and allows me to be in
            absolute control of my sugar! Highly recommended for people trying
            to control there sugar and maintain optimal body weight.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The pursuit of good health',
      userName: 'Srinath Rajam',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '2 Nov 2022',
      since: 'May 2022',
      to: 'XXX XX',
      content: {
        text: (
          <>
            ...is impossible without the ability to control one’s blood glucose
            levels. As a nutritionist and a cycling and fitness coach, I stress
            food as 80% impact on health and CGM is an indispensable tool to
            help every individual figure out foods to eat/ avoid and in the
            right quantities…
            <br /> <br />
            We all react differently to the same food so eliminating guesswork
            is an important aspect to overall metabolic health
            <br /> <br />
            Keep up the great work UH, your supporting data is amazing.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Very rare that I write a review',
      userName: 'Praneeth Pike',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '18 Jul 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            It’s super rare for me to write a review. And I’m writing this to
            appreciated that signing up for Ultrahuman is one of the best
            decisions I’ve made in 2022.
            <br /> <br />
            The continuous monitoring of glucose levels combined with the
            insights has made my body feel much better in almost all aspects of
            my health. I also exercise much better portion control and food
            choices because of this.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Definitely makes a difference in sugar control',
      userName: 'Amar Salvi',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '26 Sep 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Understanding how your blood sugar spikes makes a huge difference in
            bringing it under control. I used to have my meds regularly thinking
            that my sugar is under control, checking it once in a while. Got the
            shock of my life recently when my Hb1AC went through the roof.
            <br /> <br />
            Switching to Ultrahuman made a huge difference in bringing things
            under control in just two weeks, as I could adjust my meds and see
            how each intake and active was affecting sugar levels. Recommended!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The first app I’ve rated in a long time',
      userName: 'Manoj Adithya',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '24 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Love the app, essential for my daily life. Perfect. I should invest
            in Ultrahuman
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Awesome indeed. Kudos to the team at ULTRAHUMAN',
      userName: 'Rajiv Rai',
      purchase: 'Repeat purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '3 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            It’s been a very awesome and most rewarding two weeks on ULTRAHUMAN.
            I have learnt so much about my own body and what is right and what I
            need to do to both reduce by HBA1C (which anyways was in the range)
            and more importantly to increase my metabolic score from high 79’s
            to over mid 80’s. I am now a much happier and healthy person in just
            two weeks.
            <br /> <br />
            However I will not continue wearing one for next 4 months after
            which I will again get one and wear it for two weeks. So in my mind
            thrice a year I will wear it for 15 days at a time. I must have
            induced at least 20 persons to get it and all of them are thanking
            me for introducing a life changing device to them. This is an
            excellent wearable and I am ready to even invest in this start-up co
            of yours. Kudos to you guys.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Simply brilliant!!',
      userName: 'Sudz328',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '6 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            The app is brilliantly designed. Its easy to find the pieces of
            information you need. there’s so much you can learn through it and
            my lifestyle and diet have already improved thanks to Ultrahuman.
            <br /> <br />
            For people who value their health, this is a remarkable product.
            Lastly the performance coaches are great andhelpful and super
            prompt.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Amazing product',
      userName: 'War Of The Lords',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '19 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            I had got this just for a trial basis but then it is so good, my
            whole family of six wear it. I love how the software is soo good in
            analysis and in giving knowledge on what’s going on in our body.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'A grandstand view of my metabolic self',
      userName: 'Ashish Kole',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '20 Jul 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            For the past few years, I’ve been trying to understand how my body
            responds to food, especially sugar (and stuff made from molasses),
            which I seem to be unable to resist. The Ultrahuman app finally gave
            me a simple-to-understand view of what happens when I eat or drink
            almost immediately, when paired with the accompanying Continuous
            Glucose Monitor. Similarly, while the app has a provision to input
            what I’ve eaten, it has lots of integration with 3rd party food
            tracking apps such as MyFitnessPal, which I use to track my food
            intake. It takes inputs about my movement / exercise from 3rd party
            devices such as Apple Watch (which I use) or Garmin, Fitbit, Oura,
            Polar or even Google Fit.
            <br /> <br />
            There’s a generous community of Ultrahuman users as well as
            Ultrahuman coaches and developers and who share insights,
            experiences, challenges and other hacks. All in all, it has been a
            journey of discovery as I discover new insights using this “lab in
            my arm”.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'I am pre diabetic',
      userName: 'AsDelhi123',
      purchase: 'Repeat purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '27 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            With this I get to know what food is having adverse effect on my
            sugar levels and which type of food keeps my sugar in range ! I have
            made 3 more family members buy it and we are all very grateful for
            this technology.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The most realistic review ever',
      userName: 'Aiken Crux 99',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '29 Aug 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Only if my body could talk and actually tell me what it needs. Or if
            my brain could interpret. Everyone will live longer and be happier.
            Ultrahuman fills that gap in the human evolutionary chain. What sets
            it apart from other CGMs is the high research and performance
            orientation, love for logic and an inspiring community that this
            brings. Other’s I have found to be too commercial. I wish this was
            more cost effective though but I do feel that the ultrahuman team is
            doing their best.
            <br /> <br />
            Cant wait for the ring! Bonus - Probably the best health focused
            content library you will find (And I have been a subscriber to most
            others before :) All the best to the team
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Phenomenal stuff',
      userName: 'MindMyWeb',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '24 Aug 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            With Ultrahuman I was able to identify small things I was doing
            wrong in my day to day life I used it to make a lifestyles program
            that is giving big results.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'A must have',
      userName: 'Laboosh1',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '12 Nov 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            I’m learning about how good effects my body every day. It doesn’t
            stop me eating some things I love that spike my insulin but at least
            I can see how other foods effect that spike.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Mind bending experience',
      userName: 'Bhargav K',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '5 May 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Hey Cyborg Team, I got my hands on the Ultrahuman Cyborg device as a
            private beta user entry and trust me there has been no going back.
            The product is top-notch in tech and explains things unseeable by
            the human body.
            <br /> <br />
            Looking forward to grow and learn more about my body with the
            product.
            <br />
            Cheers, Bhargav Super Cyborg
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Essential if you are serious about your diet',
      userName: 'Mohith4590',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '7 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            This app is absolutely essential if you are serious about your food
            intake. What you may think is good food, may not be best fit for
            your body and with the help of Ultrahuman you can see that
            quantified in numbers.
            <br /> <br />
            The app is easy to use and the insights it provides is life
            changing. I’m very happy with the experience.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Amazing product - mind blowing insights!',
      userName: 'Pushpak (pd)',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '22 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            The sensor and supporting app gives one amazing insight on how one’s
            body reacts to food intake and how best to manage health. Highly
            recommend the experience!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Superb insights and data findings',
      userName: 'Piyk19',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '25 Aug 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Really happy with the initial usage of the app and sensor. Giving me
            very useful insights into my relationship with food, sleep and
            workouts !!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The easiest hack to lose weight 😍',
      userName: 'Adilohyijnxr',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '29 Aug 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            The real-time feedback the platform gives us just stellar and super
            powerful
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Discover your body',
      userName: 'Abdulla0784',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '29 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Deep real time health insights, right from UX to product all perfect
            to the T!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: ' ',
      userName: 'Kumar Sumit Gaurav',
      purchase: 'Repeat purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '6 Jul 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Helped me immensely in knowing what triggers the sugar spike and
            what lowers it. The backend integration is superb and feedback
            mechanism is well integrated. Research and fitness module are spot
            on, helped me reduce weight by almost 6 kgs in just 20 days.
            <br /> <br />A must for all fitness freak and calories caution
            people. Also good for diabetic people. Calibration did not take
            longer and it was up and running in 1 hour max. The team must do
            research for having this application directly sense sugar level.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: ' ',
      userName: 'Raj Thakur',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '8 Aug 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            This is by far the best app for the insightful data analysis which
            helps you to track your metabolism, to add on a personal touch by
            the CEO on email for your motivation is a cherry on cake.
            <br /> <br />
            The food score, workout fuel score etc are to the point and the
            interface of the app is brilliant, good job Team Ultrahuman 👏🏻
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: ' ',
      userName: 'ParentRaj',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '23 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            The app brings out some of the key insights required for managing
            blood glucose effectively. The nudges by the app and the related
            knowledge are a great features.
            <br /> <br />
            The slack platform is quite good for learning and growing as a
            community. Some of the features are still evolving though.
          </>
        ),
      },
      starCount: 5,
    },
  ],
};

export const newM1reviews = [
  {
    title: 'Proud to Be Cyborg',
    userName: 'Hpatiluk',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '30 Jun 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        Generally I never review however here would like to congratulate the
        #Ultrahuman team for this app and insight on health management. Rated 5
        star as everything is awesome from onboarding, sensor delivery, app UI,
        activity classes, customer service, etc. Thanks!
      </>
    ),
    starCount: 5,
  },
  {
    title: 'The API for your body',
    userName: 'ApoorvSharma',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '14 Jun 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        What an amazing app experience and deep insights into how your body
        works. This truly goes out to show how each body is different and how
        nutrition can have an impact on us. Strongly recommend trying it at
        least once. Your life will never be the same!
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Great tech and even better team',
    userName: 'AK_AK_AK',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '29 Jun 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        This is a game-changer and has helped me understand multiple aspect of
        my metabolic health made me conscious about the way I eat and what I
        eat, also Ultrahuman team is super super responsive and helpful really
        loving the experience.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Brilliant app',
    userName: 'Rakannan',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '29 Jul 2022',
    since: 'Sep 2022',
    to: 'XXX XX',
    content: (
      <>
        The concept of using CGM to guide your training and food plan is
        brilliant. The app is also very well laid out.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'In love with the app',
    userName: 'Nayanava',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '6 Oct 2022',
    since: 'Aug 2022',
    to: 'XXX XX',
    content: (
      <>
        This has to be the best device after Apple Watch which helps track the
        blood glucose levels, in turn helping maintain a healthy lifestyle by
        allowing me make the right food choices while staying away from the
        others. It has kind of become like a challenge to maintain blood glucose
        levels below 110 now throughout the day!! I have quit almost all foods
        that have added sugar.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'The Ultrahuman Cyborg experience',
    userName: 'Athif Hasan',
    purchase: 'Repeat purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '23 Nov 2022',
    since: 'Sep 2022',
    to: 'XXX XX',
    content: (
      <>
        Ultrahuman M1 gave me a complete insight the impact every food has to my
        body. Did not follow any fancy diet, yet managed to educate myself
        around food, and built a sustainable & healthy lifestyle.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Absolutely Amazing! Its an integrated part of my body!',
    userName: 'Ranger3010',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '25 Jun 2022',
    since: 'Sep 2022',
    to: 'XXX XX',
    content: (
      <>
        Ultrahuman sensors are easy to wear and very effective in diet control.
        It helps me track my calorie intake and allows me to be in absolute
        control of my sugar! Highly recommended for people trying to control
        there sugar and maintain optimal body weight.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'The pursuit of good health',
    userName: 'Srinath Rajam',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '2 Nov 2022',
    since: 'May 2022',
    to: 'XXX XX',
    content: (
      <>
        ...is impossible without the ability to control one’s blood glucose
        levels. As a nutritionist and a cycling and fitness coach, I stress food
        as 80% impact on health and CGM is an indispensable tool to help every
        individual figure out foods to eat/ avoid and in the right quantities…
        <br /> <br />
        We all react differently to the same food so eliminating guesswork is an
        important aspect to overall metabolic health
        <br /> <br />
        Keep up the great work UH, your supporting data is amazing.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Very rare that I write a review',
    userName: 'Praneeth Pike',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '18 Jul 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        It’s super rare for me to write a review. And I’m writing this to
        appreciated that signing up for Ultrahuman is one of the best decisions
        I’ve made in 2022.
        <br /> <br />
        The continuous monitoring of glucose levels combined with the insights
        has made my body feel much better in almost all aspects of my health. I
        also exercise much better portion control and food choices because of
        this.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Definitely makes a difference in sugar control',
    userName: 'Amar Salvi',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '26 Sep 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        Understanding how your blood sugar spikes makes a huge difference in
        bringing it under control. I used to have my meds regularly thinking
        that my sugar is under control, checking it once in a while. Got the
        shock of my life recently when my Hb1AC went through the roof.
        <br /> <br />
        Switching to Ultrahuman made a huge difference in bringing things under
        control in just two weeks, as I could adjust my meds and see how each
        intake and active was affecting sugar levels. Recommended!
      </>
    ),
    starCount: 5,
  },
  {
    title: 'The first app I’ve rated in a long time',
    userName: 'Manoj Adithya',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '24 Oct 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        Love the app, essential for my daily life. Perfect. I should invest in
        Ultrahuman
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Awesome indeed. Kudos to the team at ULTRAHUMAN',
    userName: 'Rajiv Rai',
    purchase: 'Repeat purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '3 Jun 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        It’s been a very awesome and most rewarding two weeks on ULTRAHUMAN. I
        have learnt so much about my own body and what is right and what I need
        to do to both reduce by HBA1C (which anyways was in the range) and more
        importantly to increase my metabolic score from high 79’s to over mid
        80’s. I am now a much happier and healthy person in just two weeks.
        <br /> <br />
        However I will not continue wearing one for next 4 months after which I
        will again get one and wear it for two weeks. So in my mind thrice a
        year I will wear it for 15 days at a time. I must have induced at least
        20 persons to get it and all of them are thanking me for introducing a
        life changing device to them. This is an excellent wearable and I am
        ready to even invest in this start-up co of yours. Kudos to you guys.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Simply brilliant!!',
    userName: 'Sudz328',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '6 Oct 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        The app is brilliantly designed. Its easy to find the pieces of
        information you need. there’s so much you can learn through it and my
        lifestyle and diet have already improved thanks to Ultrahuman.
        <br /> <br />
        For people who value their health, this is a remarkable product. Lastly
        the performance coaches are great andhelpful and super prompt.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Amazing product',
    userName: 'War Of The Lords',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '19 Oct 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        I had got this just for a trial basis but then it is so good, my whole
        family of six wear it. I love how the software is soo good in analysis
        and in giving knowledge on what’s going on in our body.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'A grandstand view of my metabolic self',
    userName: 'Ashish Kole',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '20 Jul 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        For the past few years, I’ve been trying to understand how my body
        responds to food, especially sugar (and stuff made from molasses), which
        I seem to be unable to resist. The Ultrahuman app finally gave me a
        simple-to-understand view of what happens when I eat or drink almost
        immediately, when paired with the accompanying Continuous Glucose
        Monitor. Similarly, while the app has a provision to input what I’ve
        eaten, it has lots of integration with 3rd party food tracking apps such
        as MyFitnessPal, which I use to track my food intake. It takes inputs
        about my movement / exercise from 3rd party devices such as Apple Watch
        (which I use) or Garmin, Fitbit, Oura, Polar or even Google Fit.
        <br /> <br />
        There’s a generous community of Ultrahuman users as well as Ultrahuman
        coaches and developers and who share insights, experiences, challenges
        and other hacks. All in all, it has been a journey of discovery as I
        discover new insights using this “lab in my arm”.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'I am pre diabetic',
    userName: 'AsDelhi123',
    purchase: 'Repeat purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '27 Oct 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        With this I get to know what food is having adverse effect on my sugar
        levels and which type of food keeps my sugar in range ! I have made 3
        more family members buy it and we are all very grateful for this
        technology.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'The most realistic review ever',
    userName: 'Aiken Crux 99',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '29 Aug 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        Only if my body could talk and actually tell me what it needs. Or if my
        brain could interpret. Everyone will live longer and be happier.
        Ultrahuman fills that gap in the human evolutionary chain. What sets it
        apart from other CGMs is the high research and performance orientation,
        love for logic and an inspiring community that this brings. Other’s I
        have found to be too commercial. I wish this was more cost effective
        though but I do feel that the ultrahuman team is doing their best.
        <br /> <br />
        Cant wait for the ring! Bonus - Probably the best health focused content
        library you will find (And I have been a subscriber to most others
        before :) All the best to the team
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Phenomenal stuff',
    userName: 'MindMyWeb',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '24 Aug 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        With Ultrahuman I was able to identify small things I was doing wrong in
        my day to day life I used it to make a lifestyles program that is giving
        big results.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'A must have',
    userName: 'Laboosh1',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '12 Nov 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        I’m learning about how good effects my body every day. It doesn’t stop
        me eating some things I love that spike my insulin but at least I can
        see how other foods effect that spike.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Mind bending experience',
    userName: 'Bhargav K',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '5 May 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        Hey Cyborg Team, I got my hands on the Ultrahuman Cyborg device as a
        private beta user entry and trust me there has been no going back. The
        product is top-notch in tech and explains things unseeable by the human
        body.
        <br /> <br />
        Looking forward to grow and learn more about my body with the product.
        <br />
        Cheers, Bhargav Super Cyborg
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Essential if you are serious about your diet',
    userName: 'Mohith4590',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '7 Jun 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        This app is absolutely essential if you are serious about your food
        intake. What you may think is good food, may not be best fit for your
        body and with the help of Ultrahuman you can see that quantified in
        numbers.
        <br /> <br />
        The app is easy to use and the insights it provides is life changing.
        I’m very happy with the experience.
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Amazing product - mind blowing insights!',
    userName: 'Pushpak (pd)',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '22 Oct 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        The sensor and supporting app gives one amazing insight on how one’s
        body reacts to food intake and how best to manage health. Highly
        recommend the experience!
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Superb insights and data findings',
    userName: 'Piyk19',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '25 Aug 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        Really happy with the initial usage of the app and sensor. Giving me
        very useful insights into my relationship with food, sleep and workouts
        !!
      </>
    ),
    starCount: 5,
  },
  {
    title: 'The easiest hack to lose weight 😍',
    userName: 'Adilohyijnxr',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '29 Aug 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        The real-time feedback the platform gives us just stellar and super
        powerful
      </>
    ),
    starCount: 5,
  },
  {
    title: 'Discover your body',
    userName: 'Abdulla0784',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '29 Oct 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        Deep real time health insights, right from UX to product all perfect to
        the T!
      </>
    ),
    starCount: 5,
  },
  {
    title: ' ',
    userName: 'Kumar Sumit Gaurav',
    purchase: 'Repeat purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '6 Jul 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        Helped me immensely in knowing what triggers the sugar spike and what
        lowers it. The backend integration is superb and feedback mechanism is
        well integrated. Research and fitness module are spot on, helped me
        reduce weight by almost 6 kgs in just 20 days.
        <br /> <br />A must for all fitness freak and calories caution people.
        Also good for diabetic people. Calibration did not take longer and it
        was up and running in 1 hour max. The team must do research for having
        this application directly sense sugar level.
      </>
    ),
    starCount: 5,
  },
  {
    title: ' ',
    userName: 'Raj Thakur',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '8 Aug 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        This is by far the best app for the insightful data analysis which helps
        you to track your metabolism, to add on a personal touch by the CEO on
        email for your motivation is a cherry on cake.
        <br /> <br />
        The food score, workout fuel score etc are to the point and the
        interface of the app is brilliant, good job Team Ultrahuman 👏🏻
      </>
    ),
    starCount: 5,
  },
  {
    title: ' ',
    userName: 'ParentRaj',
    purchase: 'Verified purchase',
    purchase_icon: '',
    program: '12 months program',
    writtenOn: '23 Oct 2022',
    since: 'XXX XXXX',
    to: 'XXX XX',
    content: (
      <>
        The app brings out some of the key insights required for managing blood
        glucose effectively. The nudges by the app and the related knowledge are
        a great features.
        <br /> <br />
        The slack platform is quite good for learning and growing as a
        community. Some of the features are still evolving though.
      </>
    ),
    starCount: 5,
  },
];

export const reviewsForAllSection_m1_ae = {
  title_a: 'Made for all',
  subtitle_a: '4.6 out of 5 stars from 25,000+ subscribers',
  title_b: 'User Reviews',
  app_store: {
    head: 'App store',
    store_icon: '../../assets/images/app_store_icon.svg',
    store_rating: '4.9',
    cta_text: 'Download on AppStore',
    cta_redirect:
      'https://apps.apple.com/us/app/ultrahuman-meditation-sleep/id1491286709',
  },
  play_store: {
    head: 'Play store',
    store_icon: '../../assets/images/app_store_icon.svg',
    store_rating: '4.5',
    cta_text: 'Download on Playstore',
    cta_redirect:
      'https://play.google.com/store/apps/details?id=com.ultrahuman.android',
  },
  itemsForAll: [
    {
      title: 'The Ultrahuman Cyborg experience',
      userName: 'Athif Hasan',
      purchase: 'Repeat purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '23 Nov 2022',
      since: 'Sep 2022',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Ultrahuman M1 gave me a complete insight the impact every food has
            to my body. Did not follow any fancy diet, yet managed to educate
            myself around food, and built a sustainable & healthy lifestyle.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Amazing product',
      userName: 'War Of The Lords',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '19 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            I had got this just for a trial basis but then it is so good, my
            whole family of six wear it. I love how the software is soo good in
            analysis and in giving knowledge on what’s going on in our body.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Amazing product - mind blowing insights!',
      userName: 'Pushpak (pd)',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '22 Oct 2022',
      since: 'Aug 2022',
      to: 'XXX XX',
      content: {
        text: (
          <>
            The sensor and supporting app gives one amazing insight on how one’s
            body reacts to food intake and how best to manage health. Highly
            recommend the experience!
          </>
        ),
      },
      starCount: 5,
    },
  ],
  items: [
    {
      title: 'The Ultrahuman Cyborg experience',
      userName: 'Athif Hasan',
      purchase: 'Repeat purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '23 Nov 2022',
      since: 'Sep 2022',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Ultrahuman M1 gave me a complete insight the impact every food has
            to my body. Did not follow any fancy diet, yet managed to educate
            myself around food, and built a sustainable & healthy lifestyle.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Amazing product',
      userName: 'War Of The Lords',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '19 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            I had got this just for a trial basis but then it is so good, my
            whole family of six wear it. I love how the software is soo good in
            analysis and in giving knowledge on what’s going on in our body.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Amazing product - mind blowing insights!',
      userName: 'Pushpak (pd)',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '22 Oct 2022',
      since: 'Aug 2022',
      to: 'XXX XX',
      content: {
        text: (
          <>
            The sensor and supporting app gives one amazing insight on how one’s
            body reacts to food intake and how best to manage health. Highly
            recommend the experience!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Great tech and even better team',
      userName: 'AK_AK_AK',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '29 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            This is a game-changer and has helped me understand multiple aspect
            of my metabolic health made me conscious about the way I eat and
            what I eat, also Ultrahuman team is super super responsive and
            helpful really loving the experience.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Proud to Be Cyborg',
      userName: 'Hpatiluk',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '30 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Generally I never review however here would like to congratulate the
            #Ultrahuman team for this app and insight on health management.
            Rated 5 star as everything is awesome from onboarding, sensor
            delivery, app UI, activity classes, customer service, etc. Thanks !
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Absolutely Amazing! Its an integrated part of my body!',
      userName: 'Ranger3010',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '25 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Ultrahuman sensors are easy to wear and very effective in diet
            control. It helps me track my calorie intake and allows me to be in
            absolute control of my sugar!
            <br /> <br />
            Highly recommended for people trying to control there sugar and
            maintain optimal body weight.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'I am pre diabetic',
      userName: 'AsDelhi123',
      purchase: 'Repeat purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '27 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            With this I get to know what food is having adverse effect on my
            sugar levels and which type of food keeps my sugar in range !
            <br /> <br />I have made 3 more family members buy it and we are all
            very grateful for this technology
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'M1 Live experience',
      userName: 'Anwar Shai',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '14 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            The M1 Live experience has been nothing but cutting edge. Streaming
            to my phone in real time my glucose level with insights on my food,
            excercise and sleep in turn helping me with small and manageable
            adjustments to optimize my life.
            <br /> <br />
            This device has done what meal plans and diets have failed to do,
            make me better without all the restrictions.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Brilliant app',
      userName: 'Rakannan',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '29 Jul 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            The concept of using CGM to guide your training and food plan is
            brilliant. The app is also very well laid out.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'In love with the app',
      userName: 'Nayanava',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '6 Oct 2022',
      since: 'Aug 2022',
      to: 'XXX XX',
      content: {
        text: (
          <>
            This has to be the best device after Apple Watch which helps track
            the blood glucose levels, in turn helping maintain a healthy
            lifestyle by allowing me make the right food choices while staying
            away from the others.
            <br /> <br />
            It has kind of become like a challenge to maintain blood glucose
            levels below 110 now throughout the day!! I have quit almost all
            foods that have added sugar.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Simply brilliant!!',
      userName: 'Sudz328',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '6 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            The app is brilliantly designed. Its easy to find the pieces of
            information you need. there’s so much you can learn through it and
            my lifestyle and diet have already improved thanks to Ultrahuman.
            <br /> <br />
            For people who value their health, this is a remarkable product.
            Lastly the performance coaches are great andhelpful and super
            prompt.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The API for your body',
      userName: 'ApoorvSharma',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '14 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            What an amazing app experience and deep insights into how your body
            works. This truly goes out to show how each body is different and
            how nutrition can have an impact on us.
            <br /> <br />
            Strongly recommend trying it at least once. Your life will never be
            the same!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The pursuit of good health',
      userName: 'Srinath Rajam',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '2 Nov 2022',
      since: 'May 2022',
      to: 'XXX XX',
      content: {
        text: (
          <>
            ...is impossible without the ability to control one’s blood glucose
            levels. As a nutritionist and a cycling and fitness coach, I stress
            food as 80% impact on health and CGM is an indispensable tool to
            help every individual figure out foods to eat/ avoid and in the
            right quantities…
            <br /> <br />
            We all react differently to the same food so eliminating guesswork
            is an important aspect to overall metabolic health Keep up the great
            work UH, your supporting data is amazing
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Very rare that I write a review',
      userName: 'Praneeth Pike',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '18 Jul 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            It’s super rare for me to write a review. And I’m writing this to
            appreciated that signing up for Ultrahuman is one of the best
            decisions I’ve made in 2022.
            <br /> <br />
            The continuous monitoring of glucose levels combined with the
            insights has made my body feel much better in almost all aspects of
            my health. I also exercise much better portion control and food
            choices because of this.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Discover your body',
      userName: 'Abdulla0784',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '29 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Deep real time health insights, right from UX to product all perfect
            to the T!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Definitely makes a difference in sugar control',
      userName: 'Amar Salvi',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '26 Sep 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Understanding how your blood sugar spikes makes a huge difference in
            bringing it under control. I used to have my meds regularly thinking
            that my sugar is under control, checking it once in a while. Got the
            shock of my life recently when my Hb1AC went through the roof.
            <br /> <br />
            Switching to Ultrahuman made a huge difference in bringing things
            under control in just two weeks, as I could adjust my meds and see
            how each intake and active was affecting sugar levels. Recommended!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The first app I’ve rated in a long time',
      userName: 'Manoj Adithya',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '24 Oct 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Love the app, essential for my daily life. Perfect. I should invest
            in Ultrahuman
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The most realistic review ever',
      userName: 'Aiken Crux 99',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '29 Aug 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Only if my body could talk and actually tell me what it needs. Or if
            my brain could interpret. Everyone will live longer and be happier.
            Ultrahuman fills that gap in the human evolutionary chain. What sets
            it apart from other CGMs is the high research and performance
            orientation, love for logic and an inspiring community that this
            brings. Other’s I have found to be too commercial. I wish this was
            more cost effective though but I do feel that the ultrahuman team is
            doing their best.
            <br /> <br />
            Cant wait for the ring! Bonus - Probably the best health focused
            content library you will find (And I have been a subscriber to most
            others before :) All the best to the team
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Awesome indeed. Kudos to the team at ULTRAHUMAN',
      userName: 'Rajiv Rai',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '3 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            It’s been a very awesome and most rewarding two weeks on ULTRAHUMAN.
            I have learnt so much about my own body and what is right and what I
            need to do to both reduce by HBA1C (which anyways was in the range)
            and more importantly to increase my metabolic score from high 79’s
            to over mid 80’s. I am now a much happier and healthy person in just
            two weeks. However I will not continue wearing one for next 4 months
            after which I will again get one and wear it for two weeks. So in my
            mind thrice a year I will wear it for 15 days at a time.
            <br /> <br />I must have induced at least 20 persons to get it and
            all of them are thanking me for introducing a life changing device
            to them. This is an excellent wearable and I am ready to even invest
            in this start-up co of yours. Kudos to you guys
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Phenomenal stuff',
      userName: 'MindMyWeb',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '24 Aug 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            With Ultrahuman I was able to identify small things I was doing
            wrong in my day to day life I used it to make a lifestyles program
            that is giving big results.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'A grandstand view of my metabolic self',
      userName: 'Ashish Kole',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '20 Jul 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            For the past few years, I’ve been trying to understand how my body
            responds to food, especially sugar (and stuff made from molasses),
            which I seem to be unable to resist. The Ultrahuman app finally gave
            me a simple-to-understand view of what happens when I eat or drink
            almost immediately, when paired with the accompanying Continuous
            Glucose Monitor. Similarly, while the app has a provision to input
            what I’ve eaten, it has lots of integration with 3rd party food
            tracking apps such as MyFitnessPal, which I use to track my food
            intake. It takes inputs about my movement / exercise from 3rd party
            devices such as Apple Watch (which I use) or Garmin, Fitbit, Oura,
            Polar or even Google Fit.
            <br /> <br />
            There’s a generous community of Ultrahuman users as well as
            Ultrahuman coaches and developers and who share insights,
            experiences, challenges and other hacks. All in all, it has been a
            journey of discovery as I discover new insights using this “lab in
            my arm”.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Essential if you are serious about your diet',
      userName: 'Mohith4590',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '7 Jun 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            This app is absolutely essential if you are serious about your food
            intake. What you may think is good food, may not be best fit for
            your body and with the help of Ultrahuman you can see that
            quantified in numbers.
            <br /> <br />
            The app is easy to use and the insights it provides is life
            changing. I’m very happy with the experience.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Mind bending experience',
      userName: 'Bhargav K',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '5 May 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Hey Cyborg Team, I got my hands on the Ultrahuman Cyborg device as a
            private beta user entry and trust me there has been no going back.
            The product is top-notch in tech and explains things unseeable by
            the human body.
            <br /> <br />
            Looking forward to grow and learn more about my body with the
            product.
            <br />
            Cheers, Bhargav Super Cyborg
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'A must have',
      userName: 'Laboosh1',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '12 Nov 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            I’m learning about how good effects my body every day. It doesn’t
            stop me eating some things I love that spike my insulin but at least
            I can see how other foods effect that spike.
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'The easiest hack to lose weight 😍',
      userName: 'Adilohyijnxr',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '29 Aug 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            The real-time feedback the platform gives us just stellar and super
            powerful
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: 'Superb insights and data findings',
      userName: 'Piyk19',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '25 Aug 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Really happy with the initial usage of the app and sensor. Giving me
            very useful insights into my relationship with food, sleep and
            workouts !!
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: ' ',
      userName: 'Kumar Sumit Gaurav',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '6 Jul 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            Helped me immensely in knowing what triggers the sugar spike and
            what lowers it. The backend integration is superb and feedback
            mechanism is well integrated. Research and fitness module are spot
            on, helped me reduce weight by almost 6 kgs in just 20 days.
            <br /> <br />A must for all fitness freak and calories caution
            people. Also good for diabetic people. Calibration did not take
            longer and it was up and running in 1 hour max. The team must do
            research for having this application directly sense sugar level
          </>
        ),
      },
      starCount: 5,
    },
    {
      title: ' ',
      userName: 'Raj Thakur',
      purchase: 'Verified purchase',
      purchase_icon: '',
      program: '12 months program',
      writtenOn: '8 Aug 2022',
      since: 'XXX XXXX',
      to: 'XXX XX',
      content: {
        text: (
          <>
            This is by far the best app for the insightful data analysis which
            helps you to track your metabolism, to add on a personal touch by
            the CEO on email for your motivation is a cherry on cake.
            <br /> <br />
            The food score, workout fuel score etc are to the point and the
            interface of the app is brilliant, good job Team Ultrahuman 👏🏻
          </>
        ),
      },
      starCount: 5,
    },
  ],
};

export const actionSection1_m1 = [
  {
    title: 'Free shipping',
    description: 'Free delivery to your doorstep in 1-2 days.',
    // 'Free delivery to your doorstep in 1-2 days. COD is available.',
  },
  {
    title: 'Free replacements & returns',
    description:
      'Enjoy up to two annual sensor replacements & hassle-free refunds for additional issues.',
    // bottomImage: <FiveStarsWhite style={{ height: '26px' }} />,
  },
  {
    title: '24x7 support',
    description: (
      <>Have a question? Chat with an M1 specialist or get a call back.</>
    ),
    buttonLabel: 'Contact Us',
    buttonAction: 'openTypeFormModal',
  },
];

export const actionSection2_m1 = [
  {
    image: chatBubbleGreyIcon.src,
    imageAltText: '',
    title: 'Have questions about buying Ultrahuman M1?',
    buttonLabel: 'Contact an M1 specialist',
    buttonAction: 'openTypeFormModal',
  },
];

// === M1 Live | AE Specific ===
export const buySectionTitle_ae = 'Buy M1 Live';

export const buySectionTitle_us = 'Buy M2 Live';
export const buySectionDescription_us = (
  <>Optimise your metabolic health with continuous glucose monitoring</>
);

export const buySectionDescription_ae = (
  <>
    {/* <b style={{ display: 'inline-block', margin: '0.4rem 0 0.4rem 0' }}>
      Live glucose experience ( NFC + Bluetooth required )
    </b> */}
    {/* <br /> */}
    Discover a personalized way to eat better and exercise smarter using the
    real-time glucose biomarker.
  </>
);

export const actionSection1_m1_ae = [
  {
    title: 'Free shipping',
    description: 'Free delivery to your doorstep in 3-4 days during Eid.',
    // 'Free delivery to your doorstep in 3-4 days during Eid. COD is available.',
  },
  {
    title: 'Free replacements & returns',
    description:
      'Enjoy up to two annual sensor replacements & hassle-free refunds for additional issues.',
    // bottomImage: <FiveStarsWhite style={{ height: '26px' }} />,
  },
  {
    title: '24x7 support',
    description: (
      <>Have a question? Chat with an M1 specialist or get a call back.</>
    ),
    buttonLabel: 'Contact us',
    buttonAction: 'openTypeFormModal',
  },
];

export const actionSection1_m1_us = [
  {
    title: 'Shipping and delivery',
    description: 'Delivered to your doorstep in 3-4 days.',
  },
  {
    title: 'Free replacements & returns',
    description:
      'Enjoy up to two annual sensor replacements & hassle-free refunds for additional issues.',
    // bottomImage: <FiveStarsWhite style={{ height: '26px' }} />,
  },
  {
    title: '24x7 support',
    description: (
      <>Have a question? Chat with an M1 Live specialist or get a call back.</>
    ),
    buttonLabel: 'Contact us',
    buttonAction: 'openTypeFormModal',
  },
];

export const actionSection1_m1_intl = [
  {
    title: 'Free shipping',
    description: 'Free shipping in 3-5 days.',
  },
  {
    title: 'Free replacements & returns',
    description:
      'Enjoy up to two annual sensor replacements & hassle-free refunds for additional issues.',
    // bottomImage: <FiveStarsWhite style={{ height: '26px' }} />,
  },
  {
    title: '24x7 support',
    description: (
      <>Have a question? Chat with an M1 Live specialist or get a call back.</>
    ),
    buttonLabel: 'Contact us',
    buttonAction: 'openTypeFormModal',
  },
];

export const actionSection2_m1_ae = [
  {
    image: chatBubbleGreyIcon.src,
    imageAltText: '',
    title: 'Have questions about buying Ultrahuman M1 Live Glucose Tracking?',
    buttonLabel: 'Contact an M1 Live specialist',
    buttonAction: 'openTypeFormModal',
  },
];

export const carousalSection_m1_ae = [
  {
    src: 'discover-metabolic-fitness-ae.png',
    srcResponsive: 'discover-metabolic-fitness-responsive-ae.png',

    thumb: 'discover-metabolic-fitness-ae.png',

    alt: '',
  },
  {
    video: true,
    src: 'https://public-web-assets-cfront.ultrahuman.com/m1/Ultrahuman-M1-Product_Video.mp4',
    poster: getCompressedAssetUrl('/m1/m1_vid_poster.png'),
    thumb: 'm1/m1_vid_thumbnail.png',

    alt: '',
  },
  {
    src: 'M1_main.png',

    srcResponsive: 'M1_main-responsive.png',

    thumb: 'M1_main.png',

    alt: '',
  },
  {
    src: 'water_friendly.png',

    srcResponsive: 'shower_friendly-responsive.png',

    thumb: 'water_friendly.png',

    alt: '',
  },
  {
    src: 'DIY_easy_application.png',

    srcResponsive: 'easy_diy-responsive.png',

    thumb: 'DIY_easy_application.png',

    alt: '',
  },
  {
    src: 'hypoallergenic.png',

    srcResponsive: 'hypoallergenic-responsive.png',

    thumb: 'hypoallergenic.png',

    alt: '',
  },
];

export const descriptionSection4_m1_ae = {
  title: 'Trusted by the best',
  items: [
    {
      image: 'web_v2/home/sports-team-UAE/1.webp/w_900',
      title: 'Team UAE Emirates',
    },
    {
      image: 'web_v2/home/sports-team-UAE/2.webp/w_900',
      title: 'Team Bahrain Victorious',
    },
    {
      image: 'web_v2/home/sports-team-UAE/uae-team-adq.png/w_900',
      title: 'UAE Team ADQ',
    },
  ],
};

/* Global */
export const buySectionTitle_global = 'Buy M1 Live';

export const buySectionDescription_global = (
  <>
    {/* <b style={{ display: 'inline-block', margin: '0.4rem 0 0.4rem 0' }}>
      Live glucose experience ( NFC + Bluetooth required )
    </b> */}
    {/* <br /> */}
    Discover a personalized way to eat better and exercise smarter using the
    real-time glucose biomarker.
  </>
);
